export default __webpack_public_path__ + "static/media/triangle.ac1cc5d3.mp3";